__turbopack_context__.v({
  "fade-in": "Landing-module-scss-module__YLRiyW__fade-in",
  "hero": "Landing-module-scss-module__YLRiyW__hero",
  "logo": "Landing-module-scss-module__YLRiyW__logo",
  "mask-off": "Landing-module-scss-module__YLRiyW__mask-off",
  "showIntro": "Landing-module-scss-module__YLRiyW__showIntro",
  "splash": "Landing-module-scss-module__YLRiyW__splash",
  "tagline": "Landing-module-scss-module__YLRiyW__tagline",
});
